
<ng-container *ngIf="!isLoading; else loading">

  <mat-drawer-container class="example-container" autosize>
    <mat-drawer *ngIf="editingItem != null" #drawer class="example-sidenav" mode="side" position="start" [opened]="editingItem != null">
      <form>
        <h2 style="text-align:center">Menu</h2>

        <widget-menu-settings [widget]="editingItem.widget"></widget-menu-settings>

        <div>
          <button type="button" mat-raised-button (click)="okayItem()">Ok</button>
          <button type="button" mat-raised-button color="warn" (click)="cancelItem()">Cancel</button>
        </div>
      </form>
    </mat-drawer>

    <mat-drawer *ngIf="secondMenuOpen" #drawer class="example-sidenav" mode="side" position="end" [opened]="secondMenuOpen">
      <p>hello</p>
    </mat-drawer>

    <div class="example-sidenav-content">
      <div style="display: flex; flex-direction: row" [style.gap]="editingItem ? '14.65%' : isPanelEditable ? '18.65%' : '25%'">
        <button *ngIf="!isPanelEditable" mat-mini-fab (click)="makePageEditbale()" class="add-button cols-2">
          <mat-icon>edit_square</mat-icon>
        </button>

        <div *ngIf="isPanelEditable" >
          <button mat-mini-fab (click)="save()" class="add-button cols-2"><mat-icon>save</mat-icon></button>
          <button mat-mini-fab (click)="saveAs()" class="add-button cols-2"><mat-icon>save_as</mat-icon></button>
          <button mat-mini-fab (click)="cancel()" class="add-button cols-2"><mat-icon>cancel</mat-icon></button>
          <button mat-mini-fab (click)="addItem()" class="add-button cols-2"><mat-icon>add</mat-icon></button>
        </div>

        

        <div style="flex: 1 1 auto; display: flex; gap: 50px">

          <div style="flex: 1; display: flex; flex-direction: column;">
            <label style="text-align: center;">Company</label>
            <companies-autocomplete (onSelectCompany)="onSelectCompany($event)"></companies-autocomplete>
          </div>

          <div style="flex: 1; display: flex; flex-direction: column; ">
            <label style="text-align: center;">Date Range</label>
            <p-calendar name="globalFilters.dateRange" [ngModel]="globalFiltersOptionalService.dateRange | async" (ngModelChange)="globalFiltersOptionalService.SetDateRange($event)" selectionMode="range" [readonlyInput]="true" inputId="range" dateFormat="dd/mm/yy" showTime="true" showSeconds="true" [showIcon]="true" showButtonBar="true"></p-calendar>
          </div>
        </div>

        <button *ngIf="!isPanelEditable" mat-mini-fab (click)="secondMenuOpener()" class="add-button cols-2" style="float: right">
          <mat-icon>menu</mat-icon>
        </button>

      </div>

      <gridster [options]="options">
        <gridster-item [id]="item.ID" [item]="item" *ngFor="let item of (editingDashboard ?? dashboard)" [style.backgroundColor]="item == selectedItem ? editingItem.widget.backgroundColour : item.widget.backgroundColour">
          <widget [widget]="item == selectedItem ? editingItem.widget : item.widget">


            <ng-template #widgetButtonsTemplate>
              <button mat-icon-button *ngIf="isPanelEditable"
                      (mousedown)="removeItem($event, item)"
                      (touchstart)="removeItem($event, item)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button *ngIf="isPanelEditable"
                      (mousedown)="editItem($event, item)"
                      (touchstart)="editItem($event, item)">
                <mat-icon>edit</mat-icon>
              </button>

              <button mat-icon-button (click)="fullScreenMode()">
                <mat-icon>fullscreen</mat-icon>
              </button>
            </ng-template>


          </widget>

        </gridster-item>
      </gridster>
    </div>

  </mat-drawer-container>


  
  

</ng-container>



<ng-template #loading>loading...</ng-template>
